<template>

    <div class="w-full border border-[#E0E0E0] flex items-center bg-white px-4 rounded-sm" >
        <font-awesome-icon icon="fa-search" class="text-[#868D96] w-3.5" />
        <input class="w-full h-10 px-2" placeholder="Mensagem ou usuário" />
    </div>

</template>

<script>

export default {
    name: 'search-input',
}

</script>
